define('app/views/configurable_item_view',['app/setup'], function(takhfifan) {

  takhfifan.ConfigurableItemView = Backbone.View.extend({

    initialize: function(options) {
      this.option = options.option;
      this.rendered = false;

      var _this = this;
      _.each(this.option.products,function(itemId){
        takhfifan.eventHub.on('configurableItemSetup:' + itemId, function() {
          if(!_this.rendered){
            _this.render();
            _this.rendered = true;
          }
        });
      });
    },

    events: {
      'click' : 'setSelected'
    },

    setSelected: function(event){
      this.chosenProducts=_.clone(_tkhProductPrices);
      var _this=this;
      var sa = this.option.superAttribute;
      var config = _tkhProductOptions;
      var finalPrice=this.model.price()/10;
      var count = 0;
      
      if(this.option.products.length == 0) {
        this.chosenProducts={};
        takhfifan.eventHub.trigger('product:attributeChosen', {attrId:sa,attrVal:-1,basePrice:this.model.price()});
      }
      else {
        var hasProduct=false;
        $.each(_this.chosenProducts,function(productId,productPrice) {
          hasProduct=false;
          $.each(_this.option.products,function(optionProductId,optionProduct) {
            if(optionProduct==productId) {
              hasProduct=true;
            }
          });
          if(!hasProduct) {
            delete _this.chosenProducts[productId];
          }
        });
      }
      var count = 0;
      for (var k in this.chosenProducts) {
          if (this.chosenProducts.hasOwnProperty(k)) {
             ++count;
          }
      }
      if(count >= 1) {
        takhfifan.eventHub.trigger('product:attributeChosen',
          {attrId:sa, attrVal:this.option.id, products:this.chosenProducts, basePrice:this.model.price()});
      }
      var $listContainer = this.$el.parents('#tkh-configurable-option-' + sa).first();
      
      this.model.updateOptions({
        products: this.option.products,
        price: this.option.price,
        superAttribute: sa,
        optionId: this.option.id
      });
      
      $listContainer.find('span.value').text(this.option.label);
    },

    render: function(args) {
      var sa = this.model.get('superAttribute');
      var mp = this.model.get('products');
      var own_sa = this.option.superAttribute;
      var op = this.option.products;
      var label = this.option.label;
      var adjustment = this.model.optionAdjustment(this.option.price, own_sa);

      if (adjustment == 0 || this.option.id == null) {
        this.$el.text(label);
      } else if (adjustment > 0) {
        this.$el.text(label + ' +' + adjustment);
      } else {
        this.$el.text(label + ' ' + adjustment);
      }

      if (sa == own_sa) {
        return false;
      }

      if (sa == null || mp.length == 0 || this.option.id == null ||
          _.intersection(op, mp).length > 0) {
        this.$el.show();
      } else {
        this.$el.hide();
      }
    }

  });

});

